import React, { useEffect, useRef, useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelVirtueyes/consultarSimcard/consultarSimcard.css'
import BuscarIcon from '../../../icones/iconesVersaoEscura/busca_preta.svg'
import {
  mudarDoppleGangerCliente,
  revelarConsultarSimcard,
  revelarDoppelgangerCliente,
  visualizarDadosRefresh
} from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal.js'
import {
  elipseVerde,
  exclamacao,
  fecharJanela
} from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarMilhar } from '../../../utils/formatarMilhar'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import { CustomTooltip } from '../../tooltip/index.jsx'

const iconeAlerta = (
  <img className="icone-alerta" src={exclamacao()} alt="exclamacao" />
)

export default function ConsultarSimcard() {
  const { setRevelarDadosCliente } = useGlobal()

  const [spinAtivo, setSpinAtivo] = useState(false)
  const { register, errors } = useForm()
  const [itens, setItens] = useState([])
  const [dsConteudoBusca, setDsConteudoBusca] = useState('')
  const [cdCliente, setCdCliente] = useState()
  const [dsCliente, setDsCliente] = useState('NULL')

  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [mensagemErro, setMensagemErro] = useState('')

  const codigo_usuario = decryptJWT('codigo')

  const despacho = useDispatch()
  const modal = useRef()

  const colunas = [
    {
      dataField: 'CD_SIMCARD',
      text: 'ID do SIM card',
      headerClasses: 'nao-selecionavel',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'OPERADORA',
      text: 'Operadora',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'CALLERID',
      text: 'Linha',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ICCID',
      text: 'ICCID',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'PLANO_TIPO',
      text: 'Plano',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'VALOR_PLANO',
      text: 'Valor',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        const valor = parseFloat(cell)
        return (
          <div className="fonte-cor-1 label-tabela-1 container-valor-consultarSimcard">
            {!valor || isNaN(valor) ? (
              <>
                <p className="valor-rs-consultarSimcard">R$</p>{' '}
                <p className="fonte-cor-1 valor-consultarSimcard"> 0.00 </p>
              </>
            ) : (
              <>
                <p className="valor-rs-consultarSimcard">R$</p>{' '}
                <p className="fonte-cor-1 valor-consultarSimcard">
                  {formatarMilhar(valor)}
                </p>
              </>
            )}
          </div>
        )
      }
    },
    {
      dataField: 'SITUACAO',
      text: 'Situação',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'CLIENTE_CODIGO',
      text: 'Cód. cliente',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell, row) => {
        return (
          <p
            onClick={() => {
              setCdCliente(cell)
              setDsCliente(row.CLIENTE_NOME)
              handleDoppelgangerCliente(row.CD_CLIENTE, cell, row.N0_NIVEL)
            }}
            className="fonte-cor-3 label-tabela-2"
          >
            {cell || '-'}
          </p>
        )
      }
    },
    {
      dataField: 'CLIENTE_NOME',
      text: 'Razão social',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    }
  ]

  let visualizarDadosRefreshVar = useSelector(
    (state) => state.virtueyesState.visualizarDadosRefresh
  )

  async function handleDoppelgangerCliente(cdCliente, noCdCliente, n0_nivel) {
    setSpinAtivo(true)
    let fatContas = []
    const contasUsuario = await api_gateway.get(
      'm1/consultar/fat_conta/contas_usuario?cd_pav_usuario=' + codigo_usuario
    )
    await Promise.all(
      contasUsuario.data.dados.map((item) => {
        fatContas.push(item.cd_fat_conta)
      })
    )
    if (contasUsuario.data.dados.length == 0) {
      fatContas = [0]
    }

    const payload = {
      login: decryptJWT('login'),
      email: decryptJWT('email'),
      codigo: codigo_usuario,
      codigoCliente: cdCliente,
      codigoClienteErpAntigo: noCdCliente,
      codigoClienteTexto: noCdCliente,
      nomeDeUsuario: decryptJWT('nomeDeUsuario'),
      perfil: decryptJWT('perfil'),
      cdSmsContaUsuario: decryptJWT('cdSmsContaUsuario'),
      id: decryptJWT('id'),
      fatContas: fatContas,
      clienteNivel: n0_nivel,
      tipoPerfil: decryptJWT('tipoPerfil'),
      clientePrimario: decryptJWT('clientePrimario'),
      clienteOriginal: decryptJWT('clienteOriginal'),
      cd_sol_perfil: decryptJWT('cd_sol_perfil'),
      userHasSMS: decryptJWT('userHasSMS'),
      fl_enviar_fora_parque: decryptJWT('fl_enviar_fora_parque'),
      userHasPrivateNetworks: decryptJWT('userHasPrivateNetworks')
    }

    try {
      const resposta = await api_gateway.get('/m1/servicos/alterar_token', {
        params: payload
      })

      localStorage.setItem('@veye-Token', resposta.data.dados.token)

      await api_gateway.get(
        `/m1/servicos/token/atualizarLogin?cd_pav_usuario=${codigo_usuario}`
      )

      if ('keyOperadora' in localStorage) {
        localStorage.removeItem('keyOperadora')
      }
      if ('keyStatusContrato' in localStorage) {
        localStorage.removeItem('keyStatusContrato')
      }

      localStorage.removeItem('temLinhasVivo')
      localStorage.setItem('codigoClienteErpAntigo', noCdCliente)

      setRevelarMensagemSucesso(true)
      setRevelarDadosCliente(true)
      despacho(revelarDoppelgangerCliente(false))
      despacho(visualizarDadosRefresh(!visualizarDadosRefreshVar))
    } catch (error) {
      setMensagemErro(error?.response?.data?.info)
      setRevelarMensagemErro(true)
    }

    setSpinAtivo(false)
    despacho(mudarDoppleGangerCliente(false))
  }

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  async function handleCancelar() {
    ColetaClickstream(1418) // virtuTabelaClientesConsultarSimcardCancelar
    setRevelarMensagemErro(false)
    despacho(revelarConsultarSimcard(false))
  }

  async function handlePesquisar() {
    if (!dsConteudoBusca) return

    setSpinAtivo(true)
    const { data } = await api_gateway.get(
      `m1/consultar/simcard_geral?busca=${dsConteudoBusca}`
    )
    setItens(data.dados)
    setSpinAtivo(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)

      if (confirmacao === true) {
        handleCancelar()
      }
    }
  }

  function botaoPressionado(event) {
    if (event.key === 'Enter') {
      event.preventDefault()

      if (!event.target.value) return

      handlePesquisar()
      setDsConteudoBusca(event.target.value)
    }
  }

  function validarNumero(id, valor) {
    const filtro = /^[0-9]+$/
    if (valor === '' || filtro.test(valor)) {
      if (id === 'campo-texto-buscar-linha') {
        setDsConteudoBusca(valor)
      }
    }
  }

  return (
    <div ref={modal}>
      <div className="modal-acao-consultar-simcard fundo-cor-6">
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Consultar simcard</div>
            </Form.Label>
            <button
              className="botao-fechar-janela"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="grupo-consultar-simcard-1">
              <div className="coluna-consultar-simcard-1">
                <Form.Group>
                  <Form.Label>
                    <div className="fonte-cor-1 label-campo">Linha / ICCID</div>
                  </Form.Label>
                  <CustomTooltip
                    text=" Informe uma linha/ICCID para pesquisar os simcards que
                        possuem estes dados"
                    textAlign="center"
                  >
                    <Form.Control
                      id="campo-texto-buscar-linha"
                      name="dsConteudoBusca"
                      onKeyDown={(e) => botaoPressionado(e)}
                      value={dsConteudoBusca}
                      maxLength={100}
                      className="campo-texto-cor-3 campo-texto"
                      type="text"
                      autoFocus
                      placeholder="Digite o nº da linha com DDD ou ICCID"
                      onChange={(e) =>
                        validarNumero(
                          'campo-texto-buscar-linha',
                          e.target.value
                        )
                      }
                      ref={register({
                        validate: { minimo: (value) => value.length > 1 }
                      })}
                    />
                  </CustomTooltip>
                  {errors.dsConteudoBusca && (
                    <p className="fonte-cor-3 label-alerta">
                      {iconeAlerta} O campo é obrigatorio.
                    </p>
                  )}
                </Form.Group>
              </div>
              <div className="coluna-consultar-simcard-2">
                <CustomTooltip text="Pesquisar">
                  <button
                    className="botao-pesquisar-redondo-acao-consultar-simcard"
                    onClick={() => handlePesquisar()}
                  >
                    <img src={BuscarIcon} />
                  </button>
                </CustomTooltip>
              </div>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="container-tabela-modal">
              <BootstrapTable
                classes="tabela-transparente-modais"
                hover
                keyField="CD_SIMCARD"
                data={itens}
                columns={colunas}
                noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
                bootstrap4
              />
            </div>
          </Col>
        </Form.Row>
        <div className="modal-acao-consultar-simcard-espacador" />
      </div>
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Ocorreu um erro. Tente novamente mais tarde."
              mensagemParagrafo2="Caso o erro persista, entre em contato com o Suporte."
              mensagemParagrafo3={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1={'O cliente ' + dsCliente + ','}
              mensagemParagrafo2={'cód. ' + cdCliente + ' foi carregado.'}
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
    </div>
  )
}
